// src/keycloak.js
import Keycloak from 'keycloak-js';

/* cria apenas UMA instância */
const kc = new Keycloak({
    url      : 'https://keycloak.bioailab.com.br',
    realm    : 'iot_hub',
    clientId : 'iot-frontend',
});

/* ① export default — usado pelo ReactKeycloakProvider */
export default kc;

/* ② getter — usado por api.js e onde mais precisar */
export const getKeycloak = () => kc;
